import { render } from "./BusinessDrawer.vue?vue&type=template&id=18e8c3fc&scoped=true"
import script from "./BusinessDrawer.vue?vue&type=script&lang=js"
export * from "./BusinessDrawer.vue?vue&type=script&lang=js"

import "./BusinessDrawer.vue?vue&type=style&index=0&id=18e8c3fc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18e8c3fc"]])

export default __exports__